import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './teacherCommentModal.scss';
import Modal from '../../../../../../../../components/Modal';

function ViewAllStudentAnswerModal(props) {
  const contentRef = useRef(null);

  useEffect(() => {
    if (!window.MathJax) return;

    if (contentRef.current) {
      window.MathJax.typesetPromise([contentRef.current]);
    }
  }, [props.show, props.studentAnswer]);

  return (
    <Modal isOpen={props.show} onClose={props.onHide} contentWidth="800px" titleName="Answer">
      <div style={{ maxHeight: '70vh' }}>
        <div
          ref={contentRef}
          dangerouslySetInnerHTML={{ __html: props.studentAnswer }}
          style={{ height: '100%' }}></div>
      </div>
    </Modal>
  );
}

ViewAllStudentAnswerModal.propTypes = {
  studentAnswer: PropTypes.string,
  show: PropTypes.func,
  onHide: PropTypes.any
};

export default ViewAllStudentAnswerModal;
